<bt-hseparator [model]="model" style="flex: 1"></bt-hseparator>